import type { ReactNode } from "react";
import { EllipsisIcon } from "lucide-react";
import { useViewportWidth } from "../../hooks/useViewportWidth";
import { Popover, PopoverTrigger, PopoverPopup } from "../ui/popover";

export function HeaderProjectActions({ children }: { readonly children: ReactNode }) {
  const width = useViewportWidth();
  const actions = (
    <div
      className="flex shrink-0 flex-wrap items-center gap-2"
      data-testid="chatheader-project-actions"
    >
      {children}
    </div>
  );
  return width >= 768 ? (
    actions
  ) : (
    <Popover>
      <PopoverTrigger
        aria-label="Project actions"
        className="flex size-touch items-center justify-center rounded-(--control-radius) text-muted-foreground hover:bg-muted/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <EllipsisIcon aria-hidden="true" className="size-4" />
      </PopoverTrigger>
      <PopoverPopup align="end" aria-label="Project actions" className="max-w-[calc(100vw-2rem)]">
        {actions}
      </PopoverPopup>
    </Popover>
  );
}
